module.exports = __webpack_public_path__ + "img/q_bg2.b16163a6.png";